import ActivityAreaService from '@/api/ActivityAreaService';
import cloneDeep from 'lodash/cloneDeep';
import i18n from '@/i18n';

const state = {
  activityAreas: null,
};

const getters = {};

const actions = {
  activityAreas({ commit }) {
    return ActivityAreaService.getActivtyAreas().then((response) => {
      const activityAreas = cloneDeep(response.data);
      activityAreas.sort((a, b) => {
        const textA = i18n.t(a.name).toLowerCase();
        const textB = i18n.t(b.name).toLowerCase();
        return textA.localeCompare(textB);
      });
      commit('activityAreas', activityAreas);
    });
  },
};

const mutations = {
  activityAreas(state, payload) {
    state.activityAreas = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
